import { render, staticRenderFns } from "./receiveAddress.vue?vue&type=template&id=85f1e106&scoped=true"
import script from "./receiveAddress.vue?vue&type=script&lang=js"
export * from "./receiveAddress.vue?vue&type=script&lang=js"
import style0 from "./receiveAddress.vue?vue&type=style&index=0&id=85f1e106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f1e106",
  null
  
)

export default component.exports